<div class="unread-email-container">
    <span class="unread-email-icon">📧</span>
    <span *ngIf="unreadCount > 0" class="unread-email-badge">
      {{ unreadCount }}
    </span>
    <span *ngIf="unreadCount === 0" class="no-unread">No unread emails</span>
  </div>
  